// extracted by mini-css-extract-plugin
export default {"root":"Menu_root__mlYQs","header":"Menu_header__uOvNa","body":"Menu_body__TlVRN"};